import React from "react";
import styled from "styled-components";

const Footer = () => {
  return (
    <Foot>
      <Inner>
        <Logo>SIARA</Logo>
        <Tagline>Pocket-sized. Salon-quality. Always with you.</Tagline>
        <Copy>© 2025 Siara Beauty. Kosovo. All rights reserved.</Copy>
      </Inner>
    </Foot>
  );
};

const Foot = styled.footer`
  background: var(--dark);
  padding: 2.5rem 3rem;
  text-align: center;

  @media (max-width: 768px) {
    padding: 2rem 1.4rem;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
`;

const Logo = styled.span`
  font-family: var(--serif);
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.35em;
  color: var(--cream);
`;

const Tagline = styled.p`
  font-family: var(--sans);
  font-size: 0.75rem;
  font-weight: 300;
  letter-spacing: 0.1em;
  color: var(--rose);
`;

const Copy = styled.p`
  font-family: var(--sans);
  font-size: 0.68rem;
  font-weight: 300;
  color: rgba(253, 248, 245, 0.22);
  letter-spacing: 0.06em;
`;

export default Footer;
